const EPHEMERAL_RUN_NAVIGATION_KEY = 'admin-agent-traces-ephemeral-navigation';

export function saveEphemeralRunNavigation(runIds: ReadonlyArray<string>) {
    try {
        window.sessionStorage.setItem(
            EPHEMERAL_RUN_NAVIGATION_KEY,
            JSON.stringify(runIds),
        );
    } catch {
        // Navigation still works without browser storage; only prev/next is lost.
    }
}

export function loadEphemeralRunNavigation(): ReadonlyArray<string> {
    try {
        const value: unknown = JSON.parse(
            window.sessionStorage.getItem(EPHEMERAL_RUN_NAVIGATION_KEY) ?? '[]',
        );
        if (
            Array.isArray(value) &&
            value.every((runId) => typeof runId === 'string')
        ) {
            return value;
        }
    } catch {
        // A malformed or unavailable cache means the detail opens without controls.
    }
    return [];
}
